const useSearchDatatables = (data, query, columns) => {
  // console.log("useSearchDatatables", data);
  function search(rows) {
    return rows?.filter((row) =>
      columns.some((column) =>
        row[column] !== null
          ? row[column]?.toString().toLowerCase().indexOf(query.toLowerCase()) >
            -1
          : row[column]
      )
    );
  }

  return {
    data: data?.length > 0 ? search(data) : data,
    length: data?.length > 0 ? search(data).length : 0,
  };
};

export default useSearchDatatables;
